import React from "react";
import { Flex, Text, Image, Icon } from "@chakra-ui/react";
import { MdImageNotSupported } from "react-icons/md";
import {
  textPrimary,
  textSecondary,
  newBorder,
  white,
  backgroundLight,
} from "../../../utils/colors";
import { TbDental } from "react-icons/tb";

const TreatmentPlanClinicHeaderPublic = ({ tenant }) => {
  // console.log("tenant", tenant);
  return (
    <Flex
      align="center"
      m="0 0 0rem"
      p="0 0 1rem"
      borderBottom={`1px solid ${newBorder}`}
    >
      <Flex
        w="2.25rem"
        h="2.25rem"
        bg={white}
        border={`1px solid ${newBorder}`}
        borderRadius="50%"
        align="center"
        justify="center"
        mr="0.5rem"
        overflow="hidden"
      >
        {tenant && tenant.logo ? (
          <Image
            src={tenant && tenant.logo && tenant.logo}
            alt="logo"
            w="100%"
            h="100%"
            objectFit="cover"
          />
        ) : (
          <Flex
            align="center"
            justify="center"
            h="100%"
            w="100%"
            // borderRadius="100%"
            bg={backgroundLight}
          >
            <Icon as={TbDental} color={textSecondary} fontSize="0.75rem" />
          </Flex>
          // <Icon as={MdImageNotSupported} fontSize="1rem" color={textPrimary} />
        )}
      </Flex>
      <Flex direction="column">
        <Text
          fontSize="0.8rem"
          fontWeight="500"
          color={textPrimary}
          isTruncated
          maxW="300px"
        >
          {tenant && tenant.clinicName ? tenant.clinicName : "-"}
        </Text>
        <Flex align="center">
          <Text fontSize="xs" fontWeight="500" color={textSecondary}>
            {tenant && tenant.supportEmail ? tenant.supportEmail : "-"}
          </Text>
          {tenant && tenant.phone && tenant.phone.length > 4 ? (
            <>
              <Text fontSize="xs" fontWeight="500" color={textSecondary} mx={1}>
                |
              </Text>
              <Text fontSize="xs" fontWeight="500" color={textSecondary}>
                {tenant && tenant.phone ? tenant.phone : "-"}
              </Text>
            </>
          ) : null}

          {/* {tenant && tenant.phone && tenant.phone.length > 4 ? (
        <Flex align="center">
          
        </Flex>
          <Text fontSize="xs" fontWeight="500" color={textSecondary}>
            |
          </Text>
          <Text fontSize="xs" fontWeight="500" color={textSecondary}>
            {tenant && tenant.supportEmail ? tenant.supportEmail : "-"}
          </Text>
        </Flex>
          )} */}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default TreatmentPlanClinicHeaderPublic;
